<template>
  <div>
    <mdb-card v-if="currentState.currentStatus == 'Asking a Question' && currentState.currentCard" class="mb-4">
      <mdb-card-body v-if="currentState.iAmModerator">
        <h4>Read the following card. The players cannot see the card yet.</h4>
        <mdb-row>
          <mdb-col md="4">&nbsp;</mdb-col>
          <word-card :card="{class: 'secondary-color', text: currentState.currentCard.front}"/>
          <mdb-col md="4">&nbsp;</mdb-col>
        </mdb-row>
        <mdb-btn icon="check" @click="$emit('setStatus', 'Answering')">Let Them Answer</mdb-btn>
      </mdb-card-body>
      <mdb-card-body v-if="!currentState.iAmModerator">
        <h4>
          <span class="spinner-grow text-success"/>
          {{ currentState.moderatorName }} should be reading the current question.
        </h4>
      </mdb-card-body>
    </mdb-card>

    <mdb-card v-if="currentState.currentStatus == 'Answering'  ||
                        currentState.currentStatus == 'Reviewing Answers'" class="mb-4">
      <mdb-card-body>
        <div
          v-if="(currentState.iAmModerator || currentState.iAnswered) && currentState.currentStatus == 'Answering' ">
          <h4 v-if="!answersDone">Players Are Answering<span class="spinner-grow text-success"/></h4>
          <h4 v-if="answersDone">Everyone Has Answered!<span class="spinner-grow text-warning"/></h4>
          <h5 v-if="answersDone && !currentState.iAmModerator">Waiting on {{ currentState.moderatorName }}</h5>
          <mdb-btn v-if="currentState.iAmModerator && answersDone" icon="eye"
                   @click="$emit('setStatus','Reviewing Answers')">Review Answers
          </mdb-btn>
        </div>
        <div
          v-if="!(currentState.iAmModerator || currentState.iAnswered) && currentState.currentStatus == 'Answering' ">
          <h4>Make Your Selection</h4>
          <div class="text-info">{{ answeringText }}</div>
        </div>

        <div v-if="currentState.iAmModerator && currentState.currentStatus == 'Reviewing Answers' "
             class="text-info">
          Read the following answers aloud to everyone assembled. <i>They cannot see this list.</i>
          When you are done reading (and everyone is done laughing), click "Let Them Vote!".
        </div>
        <div v-if="!currentState.iAmModerator && currentState.currentStatus == 'Reviewing Answers' "
             class="text-info">
          <span class="spinner-grow text-success"/>
          <h3>{{ currentState.moderatorName }} should be reading the submitted answers right now.</h3>
        </div>

        <mdb-row
          v-if="game.classname == 'WrongQuestion' && currentState.iAmModerator && roundStatus == 'Reviewing Answers'">
          <mdb-col class="text-warning" md="4">
            <h4>The real question is...</h4>
            <h1>
              <mdb-icon icon="arrow-right"></mdb-icon>
            </h1>
          </mdb-col>
          <word-card :card="{class: 'primary-color-dark text-white', text: currentState.currentCard.back}"/>
          <mdb-col md="4">

            &nbsp;
          </mdb-col>

        </mdb-row>
        <mdb-row v-else>
          <mdb-col md="4">&nbsp;</mdb-col>
          <word-card :card="{class: 'secondary-color', text: currentState.currentCard.front}"/>
          <mdb-col md="4">&nbsp;</mdb-col>
        </mdb-row>
        <div
          v-if="isAnswerable && currentState.currentStatus == 'Answering' && !currentState.iAnswered && !currentState.iAmModerator">
          <mdb-input v-model="myAnswer" label="My Answer" placeholder="My Answer"/>
          <mdb-btn :disabled="!myAnswer" icon="check" size="sm" @click="submitAnswer(myAnswer)">Submit</mdb-btn>
        </div>

        <div v-if="currentState.currentStatus == 'Reviewing Answers' && currentState.iAmModerator">
          <mdb-row>
            <word-card
              v-for="answer in randomizedAnswers"
              :key="answer.playerId"
              :card="{class: 'primary-color text-white', text: answer.currentAnswer}"
              :selectable="false"/>
          </mdb-row>
          <mdb-btn icon="check" @click="$emit('setStatus','Voting')">Let Them Vote</mdb-btn>
        </div>

        <mdb-card class="default-color text-white mb-4" v-if="answersExist"><mdb-card-body>
          <mdb-row>
            <mdb-col v-for="player in this.currentState.players"
                     v-if="currentState.currentStatus == 'Answering' && player.answered"
                     :key="player.playerId"
                     class="text-left" md="3">
              <img :aria-label="player.name" :title="player.name" class="rounded-circle z-depth-1-half" height="50"
                   v-bind:src="player.avatar"/>
              <mdb-icon icon="check"/>
              {{ player.name }}
            </mdb-col>
          </mdb-row>
        </mdb-card-body></mdb-card>

      </mdb-card-body>
    </mdb-card>
    <mdb-card v-if="currentState.currentStatus == 'Voting'" class="mb-4">
      <mdb-card-body>
        <div v-if="(currentState.iAmModerator || currentState.iVoted)">
          <h4 v-if="!votingDone">Players Are Voting<span class="spinner-grow text-success"/></h4>
          <h4 v-if="votingDone">Everyone Has Voted!<span class="spinner-grow text-warning"/></h4>
          <h5 v-if="votingDone && !currentState.iAmModerator">Waiting on {{ currentState.moderatorName }}</h5>
          <mdb-btn v-if="currentState.iAmModerator && votingDone" icon="eye"
                   @click="scoreRound">Score Round
          </mdb-btn>
        </div>
        <mdb-row v-if="game.classname == 'WrongQuestion'">
          <word-card :card="{class: 'mdb-color lighten-5 text-black', text: currentState.currentCard.front}"/>
          <mdb-col md="4">
            <h1>
              <mdb-icon icon="arrow-right"></mdb-icon>
            </h1>
            <h3>The real question!</h3>

            &nbsp;
          </mdb-col>
          <word-card :card="{class: 'primary-color-dark text-white', text: currentState.currentCard.back}"/>

        </mdb-row>
        <mdb-row v-if="game.classname != 'WrongQuestion'">
          <mdb-col md="4">&nbsp;</mdb-col>
          <word-card :card="{class: 'secondary-color', text: currentState.currentCard.front}"/>
          <mdb-col md="4">&nbsp;</mdb-col>
        </mdb-row>

        <div
          v-if="!(currentState.iAmModerator || currentState.iVoted)">
          <h4>Make Your Selection</h4>
          <div class="text-info">{{ answeringText }}</div>
        </div>
        <mdb-row>
          <word-card
            v-for="answer in randomizedAnswers"
            :key="answer.playerId"
            :card="{class: 'primary-color text-white', text: answer.currentAnswer}"
            :selectable="!(currentState.iAmModerator || currentState.iVoted || answer.playerId == currentState.myPlayerId)"
            @cardSelected="votedFor(answer)"/>
        </mdb-row>
        <mdb-card class="default-color text-white mb-4" v-if="votesExist"><mdb-card-body>
          <mdb-row>
            <mdb-col v-for="player in this.currentState.players"
                     v-if="currentState.currentStatus == 'Voting' && player.voted"
                     :key="player.playerId"
                     class="text-left" md="3">
              <img :aria-label="player.name" :title="player.name" class="rounded-circle z-depth-1-half" height="50"
                   v-bind:src="player.avatar"/>
              <mdb-icon icon="check"/>
              {{ player.name }}
            </mdb-col>
          </mdb-row>
        </mdb-card-body></mdb-card>


      </mdb-card-body>
    </mdb-card>

    <scoreboard v-if="currentState.currentStatus == 'Review Scores'"
                :currentState="currentState" :game="game"/>

    <word-cards v-if="game && game.classname=='CahCah'"
                :current-state="currentState"
                :game="game"
                @cardSelected="cardSelected"/>

    <mdb-modal v-if="moderatorModal" centered class="text-center animated rotateIn" elegant
               removeBackdrop size="sm">
      <mdb-modal-header :close="false" center class="primary-color-dark text-white">
        <h3>New Moderator</h3>
      </mdb-modal-header>
      <mdb-modal-body>
        <h1>{{ currentState.moderatorName }}</h1>
      </mdb-modal-body>
    </mdb-modal>



  </div>
</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import Avatar from "../common/Avatar";
import {
  mdbBadge,
  mdbBtn,
  mdbBtnFixed,
  mdbBtnFixedItem,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbJumbotron,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbRow,
  mdbSpinner,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
} from 'mdbvue';
import WordCards from "./WordCards";
import WordCard from "./WordCard";
import Scoreboard from "./Scoreboard";

export default {
  name: "campfire-q-and-a-play",
  components: {

    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbIcon,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalTitle,
    mdbChipInput,
    mdbMask,
    mdbBadge,
    mdbSpinner,
    mdbJumbotron,
    mdbBtnFixed,
    mdbBtnFixedItem,
    mdbRow,
    mdbCol,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    Avatar,
    WordCards,
    WordCard,
    Scoreboard
  },
  watch: {
    roundStatus(n, o) {
      if (n == "Reviewing Answers" || n == "Voting") this.randomizeAnswers()
    },
    currentModerator(n,o) {
      if (!n) return
      this.showModerator()
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    currentUser() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    },
    lastError() {
      if (!this.game) return null
      else return this.game.lastError
    },
    answersDone() {
      let ans = true
      for (let p of this.currentState.players) {
        if (!p.answered && p.playerId != this.currentState.moderator) ans = false
      }
      return ans
    },
    answersExist() {
      let ans = false
      for (let p of this.currentState.players) {
        if (p.answered && p.playerId != this.currentState.moderator) ans = true
      }
      return ans
    },
    votingDone() {
      let ans = true
      for (let p of this.currentState.players) {
        if (!p.voted && p.playerId != this.currentState.moderator) ans = false
      }
      return ans
    },
    votesExist() {
      let ans = false
      for (let p of this.currentState.players) {
        if (p.voted && p.playerId != this.currentState.moderator) {
          ans = true
          console.log("Voted->",p)
        }
      }
      return ans
    },
    isAnswerable() {
      if (this.game.classname == "Dictionary" || this.game.classname == "WrongQuestion") return true
      else return false
    },
    answeringText() {
      let ret = ""
      if (this.currentState.currentStatus == "Answering") {
        if (this.game.classname == 'CahCah') ret = "Choose the answer you think other players will find the most hilarious."
        if (this.game.classname == 'Dictionary') ret = "Write a definition you think other players will think is the right one."
        if (this.game.classname == 'WrongQuestion') ret = "Answer this question honestly."
      }
      if (this.currentState.currentStatus == "Voting") {
        if (this.game.classname == 'CahCah') ret = "Choose the answer you find the most hilarious."
        if (this.game.classname == 'Dictionary') ret = "Choose the answer you think is the right definition."
        if (this.game.classname == 'WrongQuestion') ret = "Choose the answer you think is funniest for the new answer."
      }
      return ret
    },
    roundStatus() {
      return this.currentState.currentStatus
    },
    currentModerator() {
      return this.currentState.moderator
    }
  },
  props: {
    currentState: {
      type: Object,
      default: null
    },
    game: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      myAnswer: "",
      answerType: null,
      answered: false,
      randomizedAnswers: null,
      moderatorModal: false
    }
  },
  mounted() {
    if (this.roundStatus == "Reviewing Answers" || this.roundStatus == "Voting") this.randomizeAnswers()
  },
  methods: {
    showModerator() {
      this.moderatorModal = true
      setTimeout(() => {
        this.moderatorModal = false
      }, 2000)
    },
    randomizeAnswers() {
      this.randomizedAnswers = []
      for (let p of this.currentState.players) {
        if (p.currentAnswer) {
          this.randomizedAnswers.push({playerId: p.playerId, currentAnswer: p.currentAnswer})
        }
        if (p.playerId == this.currentState.moderator && this.game.classname == "Dictionary") {
          this.randomizedAnswers.push({playerId: p.playerId, currentAnswer: this.currentState.currentCard.back})
        }
      }
      this.randomizedAnswers.sort((a, b) => (0.5 - Math.random()))
    },
    votedFor(vote) {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/vote/" + this.game.sessionId, {
        player: vote,
        accessToken: this.game.accessToken
      }).then(
        (results) => {
          this.currentState.iVoted = true
          this.randomizedAnswers = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000, position: "top-center"})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    },
    cardSelected(card) {
      card.selected = true
      this.myAnswer = card
      this.answerType = "card"
      this.submitAnswer()
    },
    submitAnswer(answer) {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/answer/" + this.game.sessionId, {
        accessToken: this.game.accessToken,
        answerType: this.answerType,
        answer: this.myAnswer
      }).then(
        (results) => {
          this.myAnswer = null
          this.currentState.iAnswered = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    },
    scoreRound() {
      this.$store.dispatch("setExecuting", true)
      api.post("/campfirePlayer/score/" + this.game.sessionId, {
        accessToken: this.game.accessToken
      }).then(
        (results) => {

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)

      })
    }
  }
};
</script>
